/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit New/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AssignedDoctor from './AssignedDoctor/index'
import DateOfBirth from './DateOfBirth/index'
import FirstName from './FirstName/index'
import Gender from './Gender/index'
import LastName from './LastName/index'
import React from 'react'
import ReferralSource from './ReferralSource/index'
import Ssn from './Ssn/index'
import Title from './Title/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function New({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/New"
  
}) {
  let isMedia = useIsMedia()
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="New.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-l16': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-2-l16': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-3-l16': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-4-l16': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--g-5-l16': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--fw-6-l16': isMedia.mobile ? "wrap" : "nowrap"}}
 className={`views-block ${styles.Horizontal}`}
>
<Title
  viewPath={`${viewPath}/Title`}
/>
<FirstName
  viewPath={`${viewPath}/FirstName`}
/>
<LastName
  viewPath={`${viewPath}/LastName`}
/>
<DateOfBirth
  viewPath={`${viewPath}/DateOfBirth`}
/>
<Gender
  viewPath={`${viewPath}/Gender`}
/>
<Ssn
  viewPath={`${viewPath}/Ssn`}
/>
<div
  data-testid="New.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-5-l16': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-3-l16': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-l16': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<AssignedDoctor
  viewPath={`${viewPath}/AssignedDoctor`}
/>
<ReferralSource
  viewPath={`${viewPath}/ReferralSource`}
/>
</div>
</div>
{children}
</React.Fragment>)
}